import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default ({
    namespaced: true,

    state: {
        e1: 1,
        isValid: true,
    },

    getters: {
        e1(state) {
            return state.e1
        },
        isValid(state) {
            return state.isValid
        },
    },
    mutations: {
        cambiarValor(state, payload) {
            state.e1 = payload
        },
        sumarUno(state) {
            state.e1++
        },
        restarUno(state) {
            state.e1--
        },
        setPasoValido(state, payload) {
            state.isValid = payload
        },
        setDisabledNextButton(state) {
            state.isValid = false;
        },
    },
    actions: {
        nextStep({ commit, dispatch }) {
            if (this.getters['stepper/e1'] > 5)
                commit('cambiarValor', 1)
            else
                commit('sumarUno')
        },

        backStep({ commit, state }) {
            switch (state.e1) {
                case 1:

                    break;
                case 2:

                    break;
                case 3:

                    break;
                case 4:

                    break;
                case 5:

                    break;

                default:
                    break;
            }
            if (this.getters['stepper/e1'] !== 1) {
                commit('restarUno')
            }
        },

        pasoValido({ commit, dispatch }, payload) {
            //dispatch('nextStep')
            commit('setPasoValido', payload)
            //commit('setDisableNextButton')
        },

        disableNextButton({ commit }) {
            commit('setDisabledNextButton');
        },


    }
})